export const REJECTED_STATUS = 'RejectedFulfillment';
